import { createFormStore } from '#/shared/stores/createFormStore';

import type { TimesheetApprovalFormValues } from '../types/TimesheetApprovalFormValues';

export const useApproveFormStore = createFormStore<TimesheetApprovalFormValues>('approve-form-storage');
